module.exports = __webpack_public_path__ + "img/main.e1d87fb4.jpg";